import { action, makeObservable, observable } from "mobx";

abstract class AbstractStore {
    constructor() {
        makeObservable(this, {
            activity: observable,
            triggerActivity: action,
            filterActivity: observable,
            triggerFilterActivity: action,
            shouldRefresh: observable,
            triggerShouldRefresh: action,
        });
    }

    public shouldRefresh: boolean = false;
    public activity: boolean = false;
    public filterActivity: boolean = false;

    triggerShouldRefresh() {
        this.shouldRefresh = !this.shouldRefresh;
    }

    triggerActivity(active: boolean) {
        this.activity = active;
    }

    triggerFilterActivity(active: boolean) {
        this.filterActivity = active;
    }

    loadable<R>(F: (...args: any[]) => Promise<R>) {
        return this._wrapAsyncFunction(
            F,
            () => this.triggerActivity(true),
            () => this.triggerActivity(false)
        );
    }

    filterLoadable<R>(F: (...args: any[]) => Promise<R>) {
        return this._wrapAsyncFunction(
            F,
            () => this.triggerFilterActivity(true),
            () => this.triggerFilterActivity(false)
        );
    }

    private _wrapAsyncFunction<R>(F: (...args: any[]) => Promise<R>, Pre: () => void, Post: () => void) {
        return async (...args: any[]) => {
            Pre.bind(this)();
            try {
                return await F(...args);
            } catch (error) {
                throw error;
            } finally {
                Post.bind(this)();
            }
        };
    }
}
export default AbstractStore;
export { AbstractStore };
